import projects from "../data/projects";
import Icon from "./Icon";
import SectionHeading from "./SectionHeading";

function ProjectCard({ project }) {
  return (
    <article className="card-grid__item">
      <a
        className="project-card"
        href={project.href}
        target={project.external ? "_blank" : undefined}
        rel={project.external ? "noopener noreferrer" : undefined}
      >
        <div className="project-card__icon">
          <Icon name={project.icon} size={40} />
        </div>
        <h3 className="project-card__title">{project.title}</h3>
        <p className="project-card__desc">{project.description}</p>
        <span className="project-card__link">
          Visit Project
          <Icon name={project.external ? "external" : "arrow"} size={14} />
        </span>
      </a>
    </article>
  );
}

function Projects() {
  return (
    <section className="section section--alt" id="projects">
      <div className="container">
        <SectionHeading
          eyebrow="Recent Work"
          title="Projects We Developed"
          subtitle="A glimpse of the products and tools we have designed, built and shipped."
        />
        <div className="card-grid card-grid--2 reveal">
          {projects.map((project) => (
            <ProjectCard key={project.id} project={project} />
          ))}
        </div>
      </div>
    </section>
  );
}

export default Projects;
